import { ISearchPage } from "@/types/AppTypes";

//详情
export interface IDtpDetail {
    id: string,
    code: string,   // "询价单code",
    saleCode?: string
    shopCode?: string,     // "门户编号",
    shopName?: string,     // "门户名称",
    customerCode?: string,     // "客户编码",
    customerName?: string,     // "客户名称",
    typeNum?: string,     // "商品类别",
    status?: string,     // "状态",
    inquiryTime?: string,     // "询价日期",
    feedbackTime?: string,     // "反馈日期",
    inquiryDemand?: string,     // "询价要求",
    currencyCode?: string,     // "币种",
    currencyName?: string,     // "币种",
    stocKeeper?: string,     // "库管",
    reckoner?: string,     // "结算员",
    casher?: string,     // "财务",
    note?: string,     // "备注"
    relevanceOrderId?: string,     // "备注"3
    consignTime?: any,
    createTime?: any,
    updateTime?: any
    updateUser?:string
    details?: IDtpMaterialDetail[]
    saleId?: string
    [key: string]: any
}

//询价单商品详情
export interface IDtpMaterialDetail {
    key: string,  //自己用
    price?: string | number,  //供应商报价用
    id?: string,   // "询价单详情id",
    inquiryOrderId?: string,   // "询价单code",
    code?: string,   // "询价单code",
    materialId?: string,   // "物料id",
    materialCode?: string,   // "物料编号",
    replaceCode?: string,   // "替换号",
    materialName?: string,   // "物料名称",
    materialEname?: string,   // "物料名称",
    typeCode?: string,   // "物料类型",
    typeName?: string,   // "物料类型名称",
    num?: string | number,   // "询价数量",
    model?: string,   // "规格",
    note?: string,   // "备注"
    isOffer?: string,   // "是否报价"
    [key: string]: any
}

//新增
export interface IDtpInsert extends IDtpDetail {

}

//编辑
export interface IDtpUpdate extends IDtpInsert {
    id: string,
}

//搜索条件
export interface IDtpSearchFields {
    code?: string,   // "询价单号",
    customerName?: string,   // "客户名称",
    shopCode?: string,   // "门店Code",
    status?: string,   // "状态"
}

export interface IDtpSearch
    extends IDtpSearchFields, ISearchPage {

}


/**
 * 详情
 */
//tab枚举
export enum IDtpTabEnum {
    BASE_DETAIL,  //基础数据
    POWER_OF_ATTRONEY, //订舱委托书
    EXTRACT, //提单管理
    RELEVANCE_TASK, //关联单据
    FILES,   //附件管理
    APPROVER_DETAIL,   //审批明细
}

/*************供应商报价****************/
export interface ISupplierPriceDialog {
    visible: boolean,
    mode: 'add' | 'edit'
}

//供应商报价详情
export interface ISupplierOfferDetails {
    id: string,
    "shopCode"?: string,  // "code",
    "shopName"?: string,  // "门户名称",
    "inquiryOrderCode"?: string,  // "1",
    "supplierId"?: string,  // "供应商id",
    "supplierCode"?: string,  // "SUP-M-00000414",
    "supplierName"?: string,  // "供应商名称",
    "contact"?: string,  // "联系人",
    "phone"?: string,  // "电话",
    "code"?: string,  // "电话",
    "status"?: string,  // "反馈日期",
    details?: ISupplierMaterialDetails[]
}

//供应商报价商品详情
export interface ISupplierMaterialDetails {
    key?: string,
    id?: string,
    "inquiryOrderDetailsId"?: string,    // "询价单详情id",
    "materialCode"?: string,    // "物料编号",
    "replaceCode"?: string,    // "替换号",
    "materialName"?: string,    // "物料名称",
    "materialEname"?: string,    // "物料名称",
    "typeCode"?: string,    // "物料类型",
    "typeName"?: string,    // "物料类型名称",
    "num"?: string | number,    // 5,
    "price"?: string | number,    // 99,
    "amount"?: string | number,    // 99,
    "model"?: string,    // "规格",
    "note"?: string,    // "备注"
    createTime?: string,
    createUser?: string,
    deleteFlag?: string,
    updateTime?: string,
    updateUser?: string,
    giftsNum?: string,
}

//供应商报价新增
export interface ISupplierOfferInsert extends ISupplierOfferDetails {
    "inquiryOrderCode"?: string,
}

//供应商报价编辑
export interface ISupplierOfferUpdate extends ISupplierOfferInsert {
    id: string,
}

//搜索条件
export interface ISupplierOfferSearchFields {

}

export interface ISupplierOfferSearch
    extends ISupplierOfferSearchFields, ISearchPage {

}
export interface examineFields {
    "code": string,// "code",
    "status": number,// "0通过1驳回",
    "advise": string,// "审批意见"
}
export interface IBillLadingDetail {
    code?: string, //"YSDJ_00000000"
    createTime?: string, //"2022-05-26T12?:29?:06"
    createUser?: string, //"郝磊"
    deleteFlag?: string, //0
    id?: string, //"ecee42dbddd909ca0f67cf29eb9801e9"
    md5?: string, //"6b131e579fe14b948018862ac53de992.jpg"
    name?: string, //"timg.jpg"
    typeCode?: string, //"image/jpeg"
    typeName?: string, //"image/jpeg"
    updateTime?: string, //"2022-05-26T12:29:05"
    [key: string]: any
}
export interface IBillLadingInsert {
    code: string, // "单据code",
    name: string, // "附件名称",
    typeCode: string, // "附件类型编码",
    typeName: string, // "附件类型名称"
    md5: string
}
export interface IBillLadingUpdate extends IBillLadingInsert {
    id: string,
    [key: string]: any
}
export interface IBillLadingSearchFields {
    code?: string;
}
export interface IBillLadingSearch
    extends IBillLadingSearchFields, ISearchPage {

}